import { routeNames } from './routeNames';

/**
 * Left-nav items and page-hero icons (single source of truth).
 * @type {Array<{ routeName: string, icon: string, titleKey?: string, title?: string, permission?: string }>}
 */
export const NAV_ITEMS = [
  { routeName: routeNames.flightManager, icon: 'mdi-airplane-takeoff', titleKey: 'menu.flightmanager' },
  { routeName: routeNames.manageAirline, icon: 'mdi-airplane', title: 'Airline Manager', permission: 'View-Airline' },
  { routeName: routeNames.manageGate, icon: 'mdi-door-open', titleKey: 'menu.gateManager', permission: 'View-Gate' },
  { routeName: routeNames.manageCheckinRow, icon: 'mdi-ticket-confirmation-outline', title: 'Check-in Rows Manager', permission: 'View-CheckinRow' },
  { routeName: routeNames.manageClaim, icon: 'mdi-bag-suitcase-outline', title: 'Claim Manager', permission: 'View-Claim' },
  { routeName: routeNames.manageStatus, icon: 'mdi-traffic-light-outline', title: 'Flight Status Manager', permission: 'View-Status' },
  { routeName: routeNames.manageUser, icon: 'mdi-account-group-outline', titleKey: 'menu.manageUser', permission: 'View-User' },
  { routeName: routeNames.manageRole, icon: 'mdi-shield-account-outline', titleKey: 'menu.manageRole', permission: 'View-Role' },
];

/** Child / edit routes use the same hero icon as their manager parent. */
const ROUTE_ICON_PARENT = {
  [routeNames.newGate]: routeNames.manageGate,
  [routeNames.editGate]: routeNames.manageGate,
  [routeNames.newClaim]: routeNames.manageClaim,
  [routeNames.editClaim]: routeNames.manageClaim,
  [routeNames.newStatus]: routeNames.manageStatus,
  [routeNames.editStatus]: routeNames.manageStatus,
  [routeNames.newAirline]: routeNames.manageAirline,
  [routeNames.editAirline]: routeNames.manageAirline,
  [routeNames.newCheckinRow]: routeNames.manageCheckinRow,
  [routeNames.editCheckinRow]: routeNames.manageCheckinRow,
  [routeNames.newUser]: routeNames.manageUser,
  [routeNames.editUser]: routeNames.manageUser,
  [routeNames.newUserRole]: routeNames.manageRole,
  [routeNames.editUserRole]: routeNames.manageRole,
};

/**
 * MDI icon class for a route (matches left navigation).
 * @param {string|null|undefined} routeName
 * @returns {string|null}
 */
export function getNavIconForRoute(routeName) {
  if (!routeName) return null;
  const parent = ROUTE_ICON_PARENT[routeName] || routeName;
  const item = NAV_ITEMS.find((entry) => entry.routeName === parent);
  return item ? item.icon : null;
}
